import { isValid } from 'clients/Clients';
import { getMegaBlockProductConfig } from 'clients/MarketingClient';
import { TypeProductMegaBlock } from 'components-v2/organisms/pages/home/types/home-mega-block';
import { useAuth } from 'context/Auth';
import { useEffect, useMemo, useState } from 'react';

const TIME_CACHE = 900000; // 15 minutes
const MEGA_BLOCK_CACHE_KEY = 'MEGA_BLOCK_CONFIG_CACHE_1';

export const useGetMegaBlockConfig = () => {
  const { user } = useAuth();
  const [data, setData] = useState<TypeProductMegaBlock[]>();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const megaBlockConfigs = useMemo(() => {
    if (!data) return [];

    let position1;
    let position2;
    let hasPosition1 = false;
    let hasPosition2 = false;

    data?.forEach((item) => {
      if (item && Array.isArray(item.skuTags) && item.skuTags.length > 0) {
        if ((!item.position || item.position === 1) && !hasPosition1) {
          position1 = item;
          hasPosition1 = true;
        }

        if (item.position === 2 && !hasPosition2) {
          position2 = item;
          hasPosition2 = true;
        }
      }
    });

    return [position1, position2];
  }, [data]);

  const fetchData = async () => {
    //set loading
    setLoading(true);
    try {
      getMegaBlockProductConfig({ getUsing: true }).then(
        (res) => {
          if (isValid(res)) {
            setData(res.data);
          }
        },
        () => {
          setData([]);
        },
      );
    } catch (error) {
      setError(error);
      console.error(error);
    } finally {
      // set loading false
      setLoading(false);
    }
  };

  // Config phụ thuộc khách đang đăng nhập nên phải gọi lại khi biết khách là ai,
  // không thì giữ nguyên kết quả của lượt gọi ẩn danh lúc mới mount.
  useEffect(() => {
    fetchData();
  }, [user?.customerID]);

  return { data: megaBlockConfigs, error, loading };
};

